
import moment from "moment";
import { EntityRepository, Repository } from "typeorm";
import { AttendanceEntity } from "../entities/attendance.entity";
import { EmployeeAttendanceQueryResponse } from "./emp-attn.query.response";
import { ShiftWiseEmpCountResponse } from "./shift-emp-count.response";

@EntityRepository(AttendanceEntity)
export class AttendanceRepository extends Repository<AttendanceEntity> {

    constructor() {
        super();
    }

    async getAttendanceRecordsByDate(date: string, departmentId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, employee_name, in_time, out_time, department_id, shift, count(1) as count `)
            .where(` DATE = '${date}' AND present_status = "P" AND is_active = true `);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        // query.groupBy(` department_id`)
        query.orderBy(` employee_id`)
        return await query.getRawMany();
    }

    async getEmpAttenRecordByDateEmpCode(date: string, empCode?: string): Promise<EmployeeAttendanceQueryResponse> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, employee_name, in_time, out_time, department_id, shift `)
            .where(` DATE = '${date}' AND present_status = "P"`);
        if (empCode) {
            query.andWhere(` employee_code = '${empCode}' `)
        }
        return await query.getRawOne();
    }

    async getAttendanceRecordsByMonth(month: number, departmentId?: number, unitId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
        console.log(unitId)
        const query = this.createQueryBuilder('attendance')
            .select(` date, employee_id, employee_code, employee_name, present_status, department_id, shift, unit_id, day `)
            .where(` month = '${month}' `);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        if (unitId) {
            query.andWhere(` unit_id = ${unitId} `)
        }
        // query.groupBy(` department_id`)
        query.orderBy(` employee_code, day`)
        return await query.getRawMany();
    }

    async getMonthRecordsForEmp(employeeId: number, month: number, departmentId?: string, shift?: string): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, employee_name, present_status, department_id, shift, count(1) as count`)
            .where(` month = '${month}' AND employee_id = ${employeeId} `);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId}`)
        }
        if (shift) {
            query.andWhere(` shift = ${shift} `)
        }
        query.groupBy(` present_status`)
        return await query.getRawMany();
    }

    async getWorkingHoursAttendanceRecordsByDate(startDate: string, endDate: string, departmentId?: number): Promise<
        EmployeeAttendanceQueryResponse> {
        const query = this.createQueryBuilder('attendance')
            .select("SUM(IF(HOUR(TIMEDIFF(out_time,in_time))<8,IF(present_status='P',1,0),0)) AS lh, \
            SUM(IF(((in_time!='0000-00-00 00:00:00' AND out_time='0000-00-00 00:00:00') OR TIMEDIFF(out_time,in_time)='00:00:00' ),IF(present_status='P',1,0),0)) AS sm, \
            SUM(IF(`present_status`='WFH',1,0)) AS wfh,SUM(IF(`present_status`='A',1,0)) AS absent, \
            SUM(IF(`present_status`='L',1,0)) AS leaves")
            .where(` date BETWEEN '${startDate}' AND '${endDate}'`);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        return await query.getRawOne();
    }

    async getWorkingHoursTopRecordsByDate(fromDate: string, toDate: string, departmentId?: number): Promise<
        any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_code,employee_Name,COUNT(employee_code) AS days_less_than_8_hours,TIMEDIFF(out_time,in_time) AS total_hours")
            .where(`HOUR(TIMEDIFF(out_time,in_time))>0 AND HOUR(TIMEDIFF(out_time,in_time))<8 AND DATE BETWEEN '${fromDate}' AND '${toDate}' AND present_status='P' GROUP BY employee_code ORDER BY days_less_than_8_hours DESC, total_hours ASC LIMIT 5`)

        console.log()
        // if (departmentId) {
        //     query.andWhere(` department_id = ${departmentId} `)
        // }
        return await query.getRawMany();
    }

    async getSwipeMissingTopRecordsByDate(fromDate: string, toDate: string, departmentId?: number): Promise<
        any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_Name,COUNT(1) AS no_of_days_swipe_miss,TIMEDIFF(out_time,in_time) AS time_diff,out_time")
            .where(`((in_time!='0000-00-00 00:00:00' AND out_time='0000-00-00 00:00:00') OR TIMEDIFF(out_time,in_time)='00:00:00' ) AND DATE BETWEEN '${fromDate}' AND '${toDate}' AND present_status='P' GROUP BY employee_code ORDER BY no_of_days_swipe_miss DESC LIMIT 5`)

        // if (departmentId) {
        //     query.andWhere(` department_id = ${departmentId} `)
        // }
        const data = await query.getRawMany();
        return data
    }

    async getTopWFHRecordsByDate(fromDate: string, toDate: string, departmentId?: number): Promise<
        any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_code,employee_Name,COUNT(1) AS no_of_wfh")
            .where(`DATE BETWEEN '${fromDate}' AND '${toDate}' AND present_status='WFH' GROUP BY employee_code
          ORDER BY no_of_wfh DESC LIMIT 5`)
        return await query.getRawMany();
    }

    async getTopLeaveRecordsByDate(fromDate: string, toDate: string, departmentId?: number): Promise<
        any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_name,COUNT(1) AS no_of_leave_days")
            .where(`DATE BETWEEN '${fromDate}' AND '${toDate}' AND present_status='L' GROUP BY employee_code ORDER BY no_of_leave_days DESC LIMIT 5`)
        return await query.getRawMany();
    }

    async getWfhAttendanceRecordsByDate(date: string, departmentId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, department_id, shift, count(1) as count `)
            .where(` DATE = '${date}' AND present_status = "WFH" AND is_active = true `);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        // query.groupBy(` `)
        query.orderBy(` employee_id`)
        return await query.getRawMany();
    }

    async getAbsentAttendanceRecordsByDate(date: string, departmentId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, department_id, shift, count(1) as count `)
            .where(` DATE = '${date}' AND present_status = "A" AND is_active = true `);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        // query.groupBy(` `)
        query.orderBy(` employee_id`)
        return await query.getRawMany();
    }

    async getLeaveAttendanceRecordsByDate(date: string, departmentId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, department_id, shift, count(1) as count `)
            .where(` DATE = '${date}' AND present_status = "L" AND is_active = true `);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        // query.groupBy(` `)
        query.orderBy(` employee_id`)
        return await query.getRawMany();
    }

    async getEmpAttendanceRecordByDate(date: string, empCode: string): Promise<EmployeeAttendanceQueryResponse> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, department_id, shift, present_status, log_date, download_date, shift_group, in_time, out_time, flag`)
            .where(` date = '${date}' AND employee_code = '${empCode}' `)
        return await query.getRawOne();
    }

    async getAttendanceRecordsByDateAndShift(date: string, shift?: string, unitId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, unit_id, department_id, shift, count(1) as count `)
            .where(` DATE = '${date}' AND present_status = "P"  AND is_active = true`);
        if (shift) {
            query.andWhere(` shift = '${shift}' `)
        }
        if (unitId) {
            query.andWhere(` unit_id = '${unitId}' `)
        }
        query.groupBy(` department_id, shift`)
        query.orderBy(` shift, department_id`)
        return await query.getRawMany();
    }

    async getShiftWiseAttendanceByDate(fromDate: string, toDate: string, shift?: string): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` shift, count(1) as count, log_date `)
            .where(` DATE(log_date) BETWEEN '${fromDate}' AND '${toDate}' AND present_status = "P" `);
        if (shift) {
            query.andWhere(` shift = '${shift}' `)
        }
        query.groupBy(` shift, DATE(log_date)`)
        query.orderBy(` shift, DATE(log_date)`)
        return await query.getRawMany();
    }

    async getShiftWiseEmpCountByDate(date: string, shift?: string): Promise<ShiftWiseEmpCountResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` shift, count(1) as count `)
            .where(` date = '${date}' `);
        if (shift) {
            query.andWhere(` shift = '${shift}' `)
        }
        return await query.getRawMany();
    }

    async getDeptEmpCountShiftWise(date: string, deptId?: number, shift?: string): Promise<EmployeeAttendanceQueryResponse> {
        const query = this.createQueryBuilder('')
            .select(` department_id, shift, count(1) as count`)
            .where(` date = '${date}' `);
        if (shift) {
            query.andWhere(` shift = '${shift}' `)
        }
        if (deptId) {
            query.andWhere(` department_id = '${deptId}'`)
        }
        return await query.getRawOne();
    }
    async getTotalAbsentsInMonth(fromDate: string, toDate: string): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select(`employee_code,employee_name AS empname,COUNT(employee_code) AS count`)
            .where(`present_status="A" AND DATE BETWEEN '${fromDate}' AND '${toDate}' AND is_active = true GROUP BY employee_code ORDER BY COUNT(employee_code) DESC LIMIT 10`)
        return await query.getRawMany();
    }

    async getTotalLessWorkingHoursInMonth(fromDate: string, toDate: string): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select(`employee_code,employee_name AS empname,COUNT(employee_code) AS days_less_than_8_hours, SUM(HOUR(TIMEDIFF(out_time,in_time))) AS total_hours`)
            .where(`present_status="P" AND HOUR(TIMEDIFF(out_time,in_time))>= 0 AND HOUR(TIMEDIFF(out_time,in_time))<8 AND DATE BETWEEN '${fromDate}' AND '${toDate}' AND is_active = true GROUP BY employee_code ORDER BY days_less_than_8_hours DESC LIMIT 10`)
        return await query.getRawMany();
    }

    async getTotalLessWorkingHoursData(fromDate: string, toDate: string): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select(`employee_code AS employeeCode, employee_name AS employeeName, date AS date, in_time AS inTime, out_time AS outTime, shift as shift, Concat(HOUR(TIMEDIFF(out_time, in_time)), ':' , MINUTE(TIMEDIFF(out_time, in_time)) % 60) AS totalHours`)
            .where(`present_status="P" AND in_time IS NOT NULL AND (out_time IS NULL OR (shift = 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 12 AND (MINUTE(TIMEDIFF(out_time, in_time)) % 60) < 55)  OR (shift = 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 11) OR (shift != 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 8 AND (MINUTE(TIMEDIFF(out_time, in_time)) % 60) < 55) OR (shift != 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 7)) AND DATE BETWEEN '${fromDate}' AND '${toDate}' AND hr_status = false AND is_active = true ORDER BY date DESC `)
        return await query.getRawMany();
    }

    async getCriteriaNotMatchingData(fromDate: string, toDate: string): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select(`employee_code AS employeeCode, employee_name AS employeeName, date AS date, in_time AS inTime, out_time AS outTime, shift as shift, Concat(HOUR(TIMEDIFF(out_time, in_time)), ':' , MINUTE(TIMEDIFF(out_time, in_time)) % 60) AS totalHours, present_status as presentStatus, reason as reason `)
            .where(` in_time IS NOT NULL AND (out_time IS NULL OR (shift = 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 12  AND (MINUTE(TIMEDIFF(out_time, in_time)) % 60) < 55) OR (shift = 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 11) OR (shift != 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 8 AND (MINUTE(TIMEDIFF(out_time, in_time)) % 60) < 55) OR (shift != 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 7)) AND DATE BETWEEN '${fromDate}' AND '${toDate}' AND hr_status = true AND is_active = true ORDER BY date DESC `)
        return await query.getRawMany();
    }

    async getDailyShiftWiseEmpCountByDate(date: string, shift?: string): Promise<ShiftWiseEmpCountResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` shift, count(1) as count `)
            .where(` date = '${date}'  AND is_active = true `);
        if (shift) {
            query.andWhere(` shift = '${shift}' `)
        }
        return await query.getRawMany();
    }

    async getDailyWorkingHoursAttendanceRecordsByDate(startDate: string, endDate: string, departmentId?: number): Promise<EmployeeAttendanceQueryResponse> {
        const query = this.createQueryBuilder('attendance')
            .select("SUM(IF(HOUR(TIMEDIFF(out_time,in_time))<8,IF(present_status='P',1,0),0)) AS lh, \
            SUM(IF(((in_time!='0000-00-00 00:00:00' AND out_time='0000-00-00 00:00:00') OR TIMEDIFF(out_time,in_time)='00:00:00' ),IF(present_status='P',1,0),0)) AS sm, \
            SUM(IF((in_time IS NOT NULL AND out_time IS NULL ),IF(present_status='P',1,0),0)) AS present, \
            SUM(IF(`present_status`='WFH',1,0)) AS wfh, \ SUM(IF(`present_status`='A',1,0)) AS absent, \
            SUM(IF(`present_status`='L',1,0)) AS leaves")
            .where(` date BETWEEN '${startDate}' AND '${endDate}'  AND is_active = true `);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        return await query.getRawOne();
    }

    async getDailyWorkingHoursTopRecordsByDate(date: string, departmentId?: number): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_Name,TIMEDIFF(out_time,in_time) AS time_diff")
            .where(`HOUR(TIMEDIFF(out_time,in_time)) > 0 AND HOUR(TIMEDIFF(out_time,in_time))<8 AND DATE='${date}' AND present_status='P' ORDER BY time_diff ASC LIMIT 5`)

        // if (departmentId) {
        //     query.andWhere(` department_id = ${departmentId} `)
        // }
        return await query.getRawMany();
    }

    async getDailySwipeMissingTopRecordsByDate(date: string, departmentId?: number): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_Name,TIMEDIFF(out_time,in_time) AS time_diff,out_time")
            .where(`((in_time!='0000-00-00 00:00:00' AND out_time='0000-00-00 00:00:00') OR TIMEDIFF(out_time,in_time)='00:00:00' ) AND DATE='${date}' AND present_status='P' AND is_active = true ORDER BY in_time DESC LIMIT 5`)

        // if (departmentId) {
        //     query.andWhere(` department_id = ${departmentId} `)
        // }
        const data = await query.getRawMany();
        return data
    }
    async getDailyTopWFHRecordsByDate(date: string, departmentId?: number): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_Name,TIMEDIFF(out_time,in_time) AS time_diff")
            .where(`HOUR(TIMEDIFF(out_time,in_time)) AND HOUR(TIMEDIFF(out_time,in_time)) AND DATE='${date}' AND present_status='WFH' ORDER BY employee_code ASC LIMIT 5`)

        console.log()
        // if (departmentId) {
        //     query.andWhere(` department_id = ${departmentId} `)
        // }
        return await query.getRawMany();
    }

    async getDailyTopLeaveRecordsByDate(date: string, departmentId?: number): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_Name,TIMEDIFF(out_time,in_time) AS time_diff")
            .where(`DATE='${date}' AND present_status='L' ORDER BY employee_code ASC LIMIT 5`)

        console.log()
        // if (departmentId) {
        //     query.andWhere(` department_id = ${departmentId} `)
        // }
        return await query.getRawMany();
    }

    async getDailyUnitWiseAttendanceRecordsByDate(startDate: string, endDate: string, unitId?: number, departmentId?: number): Promise<EmployeeAttendanceQueryResponse> {
        const query = this.createQueryBuilder('attendance')
            .select("SUM(IF(HOUR(TIMEDIFF(out_time,in_time))<7, IF(present_status='P',1,0),0)) AS lh, \
            SUM(IF((in_time IS NOT NULL AND out_time IS NULL), IF(present_status='P',1,0),0)) AS sm, SUM(IF(`present_status`='P',1,0)) AS present, SUM(IF(`present_status`='A',1,0)) AS absent, \
            SUM(IF(`present_status`='L',1,0)) AS leaves, count(employee_code) as totalCount")
            .where(` date BETWEEN '${startDate}' AND '${endDate}' AND unit_id = '${unitId}' AND is_active = true `);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        return await query.getRawOne();
    }
}